import { memo } from "react";

import type { ReactNode } from "react";

export const DialogModalContainer = memo(function DialogModalContainer({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <div className="DialogModalContainer">
      <div>{children}</div>
    </div>
  );
});
